module.exports = __webpack_public_path__ + "a71acca8ede84451f72662a0f1966b47.pdf";